import { useEffect, useState } from "react";
import BudgetControlFilter from "./BudgetControlFilter/BudgetControlFilter";
import BudgetControlCard from "./BudgetControlCard/BudgetControlCard";
import BudgetControlTable from "./BudgetControlTable/BudgetControlTable";
import { Divider } from "@mui/material";
import { engagementIncentivesEndPointLogic } from "../../../../logic/PaidTrafficManagement/EngagementIncentives/engagementIncentivesEndPointLogic";
import SimpleBackdrop from "../../../BackDrop/BackDrop";
import { useSelector } from "react-redux";

const tableHeadings = {
  brand_name: "Brand name",
  clicks: "Clicks",
  registrations: "Registrations",
  ftd: "FTD",
  cost_per_qftd: "Cost Per QFTD",
  qftd_budget: "QFTD Budget",
  qftd_actual: "Actual QFTD",
  utilization: "Utilization",
  total_cost: "Total Cost ($)",
  modified_by: "Modified by",
  info: "Info",
};

interface BudgetControlProps {
  selectedSiteUids: any;
  userToken: any;
  siteSelectionTrigger: any;
}

const BudgetControl = ({
  selectedSiteUids,
  userToken,
  siteSelectionTrigger,
}: BudgetControlProps) => {
  const [period, setPeriod] = useState(null);
  const dataSetType = useSelector(
    (state: any) => state.engagementIncentives.dataSetType
  );
  const isClickDate = dataSetType === "click_date";
  const [exequteQueryContent, setExequteQueryContent] = useState([]) as any;
  const [exequteQueryContentQuery2, setExequteQueryContentQuery2] = useState(
    []
  ) as any;
  const [exequteQueryContentQuery3, setExequteQueryContentQuery3] = useState(
    []
  ) as any;
  const [exequteQueryContentQueryCreate, setExequteQueryContentQueryCreate] =
    useState([]) as any;
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [show, setShow] = useState<boolean>(true);
  const [display, setDisplay] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [sortedRows, setSortedRows] = useState([]);
  const QUERY_ID = isClickDate ? 5670392840585216 : 5659886813708288;
  const QUERY_ID_2 = isClickDate ? 5107442887163904 : 5711226101301248;
  const QUERY_ID_3 = 5951867817295872;
  const QUERY_ID_CREATE = 5388917863874560;

  useEffect(() => {
    const fetchAllData = async () => {
      if (startDate && endDate && show) {
        setExequteQueryContent([]);
        setExequteQueryContentQuery2([]);
        setExequteQueryContentQuery3([]);
        try {
          setLoading(true);
          setRefresh(false); // Ensure refresh is set to false initially
          await Promise.all([
            engagementIncentivesEndPointLogic.getExequteQuery(
              userToken,
              setExequteQueryContent,
              selectedSiteUids,
              startDate,
              endDate,
              QUERY_ID
            ),
            engagementIncentivesEndPointLogic.getExequteQuery(
              userToken,
              setExequteQueryContentQuery2,
              selectedSiteUids,
              startDate,
              endDate,
              QUERY_ID_2
            ),
            engagementIncentivesEndPointLogic.getExequteQuery(
              userToken,
              setExequteQueryContentQuery3,
              selectedSiteUids,
              startDate,
              endDate,
              QUERY_ID_3
            ),
          ]);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          if (
            exequteQueryContent.length > 0 &&
            exequteQueryContentQuery2.length > 0 &&
            exequteQueryContentQuery3.length > 0
          ) {
            // setLoading(false);
          }
          setShow(false);
          // setShow(false);
        }
      }
    };

    fetchAllData();
    // eslint-disable-next-line
  }, [startDate, endDate, show, selectedSiteUids]);

  useEffect(() => {
    if (
      Object.keys(exequteQueryContent).length > 0 &&
      Object.keys(exequteQueryContentQuery2).length > 0 &&
      Object.keys(exequteQueryContentQuery3).length > 0
    ) {
      setLoading(false);
    }
  }, [
    exequteQueryContent,
    exequteQueryContentQuery2,
    exequteQueryContentQuery3,
  ]);

  // Separate useEffect for refresh handling
  useEffect(() => {
    if (refresh) {
      const timer = setTimeout(() => {
        setRefresh(false); // Reset refresh after delayed rerun
        setShow(true); // This will trigger the main useEffect
      });

      return () => clearTimeout(timer); // Cleanup to prevent memory leaks
    }
  }, [refresh]);

  useEffect(() => {
    const fetchExequteQueryContentQueryCreate = async () => {
      if (startDate && endDate && show === true) {
        setLoading(true);
        try {
          // Await the API call to ensure it completes before moving on
          await engagementIncentivesEndPointLogic.getExequteQuery(
            userToken,
            setExequteQueryContentQueryCreate,
            selectedSiteUids,
            startDate,
            endDate,
            QUERY_ID_CREATE
          );
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          // This ensures loading is set to false after the API call, regardless of success or failure
          // setLoading(false);
        }
      }
    };

    fetchExequteQueryContentQueryCreate();
    // eslint-disable-next-line
  }, [period, show, refresh, selectedSiteUids]);
  useEffect(() => {
    setShow(true); // This will force a re-fetch when the SELECT SITE button is clicked
  }, [siteSelectionTrigger]);
  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <BudgetControlFilter
            period={period}
            setPeriod={setPeriod}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            setShow={setShow}
            setDisplay={setDisplay}
            exequteQueryContentQueryCreate={exequteQueryContentQueryCreate}
            userToken={userToken}
            setRefresh={setRefresh}
            sortedRows={sortedRows}
            tableHeadings={tableHeadings}
          />
          {period &&
            Object.keys(exequteQueryContent).length !== 0 &&
            display &&
            !loading && (
              <>
                <Divider sx={{ mb: "10px", pt: "10px" }} />
                <BudgetControlCard exequteQueryContent={exequteQueryContent} />
                <BudgetControlTable
                  tableHeadings={tableHeadings}
                  exequteQueryContentQuery2={exequteQueryContentQuery2}
                  exequteQueryContentQuery3={exequteQueryContentQuery3}
                  exequteQueryContentQueryCreate={
                    exequteQueryContentQueryCreate
                  }
                  startDate={startDate}
                  userToken={userToken}
                  setRefresh={setRefresh}
                  setSortedRows={setSortedRows}
                  sortedRows={sortedRows}
                />
              </>
            )}
        </>
      )}
    </>
  );
};

export default BudgetControl;
